/**
 * Tabelas do banco.
 */
export const Tabelas = {
  atuacao: 'atuacao',
  comarca: 'comarca',
  configuracoes: 'configuracoes',
  conselho_superior: 'conselho_superior',
  curso: 'curso',
  defensor: 'defensor',
  defensoria: 'defensoria',
  distrito: 'distrito',
  diretoria: 'diretoria',
  endereco: 'endereco',
  estagiario: 'estagiario',
  estagiario_anexo: 'estagiario_anexo',
  estagio: 'estagio',
  feriado: 'feriado',
  funcao: 'funcao',
  historico: 'historico',
  instituicao_ensino: 'instituicao_ensino',
  lotacao: 'lotacao',
  movimentacao: 'movimentacao',
  movimentacaoregistro: 'movimentacao_registro',
  movimentacaotipo: 'movimentacao_tipo',
  notificacao: 'notificacao',
  nucleo: 'nucleo',
  periodo: 'periodo',
  pessoa: 'pessoa',
  tipo_gasto: 'tipo_gasto',
  gasto: 'gasto',
  predio: 'predio',
  regra: 'regra',
  responsavel: 'responsavel',
  setor: 'setor',
  substituicao: 'substituicao',
  telefone: 'telefone',
  usuario: 'usuario',
  vara: 'vara',
};


export const editRoutes: Record<string, string> = {
  atuacao: '/atuacao/editar',
  comarca: '/comarca/editar',
  colaborador: '/pessoa/editar',
  configuracoes: '/configuracoes/editar',
  curso: '/curso/editar',
  defensor: '/pessoa/editar',
  defensoria: '/defensoria/editar',
  distrito: '/distrito/editar',
  endereco: '/endereco/editar',
  estagiario: '/pessoa/editar',
  estagiario_anexo: '/estagiario_anexo/editar',
  //estagio: '/estagio/editar',
  feriado: '/feriado/editar',
  funcao: '/funcao/editar',
  historico: '/historico/editar',
  instituicao_ensino: '/instituicao_ensino/editar',
  lotacao: '/lotacao/editar',
  movimentacao: '/atividades/editar',
  //movimentacao_registro: '/movimentacao_registro/editar',
  //movimentacao_tipo: '/movimentacao_tipo/editar',
  notificacao: '/notificacao/editar',
  nucleo: '/nucleo/editar',
  periodo: '/periodo/editar',
  pessoa: '/pessoa/editar',
  tipo_gasto: '/office/tipo-gasto/editar',
  gasto: '/office/gasto/editar',
  predio: '/predio/editar',
  regra: '/regra/editar',
  responsavel: '/responsavel/editar',
  setor: '/setor/editar',
  substituicao: '/substituicao/editar',
  telefone: '/telefone/editar',
  usuario: '/pessoa/editar',
  vara: '/vara/editar',
};


export function getEditLink(tabela: string, registerId: string | number) {
  const r = editRoutes[tabela] ?? '';
  if (r) {
    return `${r}/${registerId}`;
  }
  return null;
}
